export default "__VITE_ASSET__BmeYI1Vd__"